import React, { useEffect, useState, useContext } from 'react';
import { updateModel } from '../../utils/api';
import '../../App.css';
import { SiteContext } from '../../App';
import DropDownSection from './DropDownSection/DropDownSection';

const PageEditView = ({ oldModel, assets = null }) => {
    const { setIsEditMode } = useContext(SiteContext);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [model, setModel] = useState(oldModel);
    const [uploadImages, setUploadImages] = useState([]);

    const handleSave = async () => {
        console.log('uploadimages: ', uploadImages);
        if (JSON.stringify(oldModel) != JSON.stringify(model)) {
            setLoading(true);
            try {
                const payload = {
                    model
                };
                const response = await updateModel(payload);
                console.log('response update', response);
            } catch (err) {
                console.error('Error updating model:', err);

                if (err.response) {
                    console.error('Error Response Data:', err.response.data);
                    alert(`Error: ${err.response.data.message || 'Failed to patch model.'}`);
                } else {
                    console.error('Request Error:', err.message);
                    alert(`Error: ${err.message}`);
                }
            } finally {
                setLoading(false);
            }
        }
        setIsEditMode(false);
    };

    if (error) return <div>{error}</div>;
    if (loading) return <div>Loading...</div>;
    if (!model) return <div>No model data available.</div>;

    return (
        <div className="container">

            {/** trying to implement save images will break */}
            <DropDownSection model={model} assets={assets} setModel={setModel} isEditMode={true} setUploadImages={setUploadImages}/>

            <div style={{ marginTop: "20px" }}>
                <button className='big-button'>Cancel</button>
                <button className='big-button' onClick={handleSave}>Save</button>
            </div>
        </div>
    );
};

export default PageEditView;
